import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

type LogisticsIncidentSelectProps = {
  onReasonChanged: (
    selectedReason: string | null,
    reasonLabel: string | null
  ) => void
}

const reasonsData = [
  {
    id: 'long_transit',
    label:
      'process_details_page.report_incident.reasons.logistics_reasons.long_transit'
  },
  {
    id: 'delivery_proof',
    label:
      'process_details_page.report_incident.reasons.logistics_reasons.delivery_proof'
  },
  {
    id: 'damaged_package',
    label:
      'process_details_page.report_incident.reasons.logistics_reasons.damaged_package'
  },
  {
    id: 'other',
    label:
      'process_details_page.report_incident.reasons.logistics_reasons.other'
  }
]

const LogisticsIncidentSelect: React.FC<LogisticsIncidentSelectProps> = ({
  onReasonChanged
}) => {
  const { t } = useTranslation()
  const [selectedReason, setSelectedReason] = useState<string | null>(null)

  const handleSelectionChange = (reasonId: string, reasonLabel: string) => {
    setSelectedReason(reasonId)
    onReasonChanged(reasonId, reasonLabel)
  }

  return (
    <div>
      {reasonsData.map((reason) => (
        <div key={reason.id} className="mb-2">
          <label>
            <input
              type="radio"
              name="reason"
              className="mr-2"
              value={reason.id}
              checked={selectedReason === reason.id}
              onChange={() => handleSelectionChange(reason.id, reason.label)}
            />
            {t(reason.label)}
          </label>
        </div>
      ))}
    </div>
  )
}

export default LogisticsIncidentSelect
